import React from 'react';
class Footer extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("footer", { className: "row" },
            React.createElement("div", { className: "col-sm-12 footer" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "element-widget col-sm" },
                        React.createElement("p", null, "Dane kontaktowe:"),
                        React.createElement("ul", null,
                            React.createElement("li", null, "tel. kom.: +48 608 673 146"),
                            React.createElement("li", null, "e-mail: mateusz.krasuski.358@gmail.com"))),
                    React.createElement("div", { className: "element-widget col-sm" },
                        React.createElement("p", null, "Repozytoriom:"),
                        React.createElement("p", null,
                            React.createElement("a", { href: "https://github.com/Saurus42" }, "https://github.com/Saurus42")))))));
    }
}
export default Footer;
